import React from 'react';
import PropTypes from 'prop-types';
import cogoToast from 'cogo-toast';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileUpload } from '@fortawesome/free-solid-svg-icons';
import UploadImage from '../../ImageUpload/UploadImage';
import CircleThumbnail from './CircleThumbnail';

function ImageField({ label, value, onChange, onUploading }) {
  return (
    <div className='circle-image-field'>
      <label htmlFor='circle-cover-image-upload'>{label}</label>
      {value && <CircleThumbnail src={value} />}
      <UploadImage
        imagesOnly
        basicUploader
        inputId='circle-cover-image-upload'
        basicUploadClass='circle-file-upload'
        basicTextExplainer={
          <span className='circle-file-upload-content'>
            <FontAwesomeIcon icon={faFileUpload} />
            <span>
              <strong>{value ? 'Choose a replacement image' : 'Choose an image file'}</strong>
              <small>JPG, PNG or WebP · Up to 10 MB</small>
            </span>
          </span>
        }
        postUploadMessageWhileCompleting='Finishing upload…'
        currentImage={value}
        onUploadProgress={() => onUploading?.(true)}
        onUploadError={() => {
          onUploading?.(false);
          cogoToast.error('Image upload failed. Please try again.');
        }}
        handlePreprocess={(file, next) => {
          if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type) || file.size > 10 * 1024 * 1024)
            return cogoToast.error('Choose a JPG, PNG, or WebP image under 10 MB');
          next(file);
        }}
        completeUpload={url => {
          onChange(url);
          onUploading?.(false);
        }}
      />
      {value && <button onClick={() => onChange(null)}>Remove image</button>}
    </div>
  );
}

ImageField.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onUploading: PropTypes.func
};

export default ImageField;
